import React from 'react';
import {MasterLayout} from 'layout';
import {AddHandleLetter} from "modules/handle-letters";
export default class AddHandleLettersPage extends React.Component {
  
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
          <AddHandleLetter params={this.props.params}/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/handle-letters/AddHandleLettersPage.jsx